export default __webpack_public_path__ + "static/media/marker15.da997aee.svg";